import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/csv/upload`;

export const ROUTE: RouteDefinition = `${baseRoute}/csv/upload`;

export const URL = (): RouteDefinition => `${baseRoute}/csv/upload`;
